import { createFileRoute } from '@tanstack/react-router'

import { FINANCE_ROLES, holdsAny } from '@brickup/shared/constants'
import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { financeListFilters } from '@/components/Internal/Finance/finance-list-filters'
import { FinanceView } from '@/components/Internal/Finance/FinanceView'
import { AccessDeniedError, requireAuth } from '@/utils/require-auth'

/**
 * Narrower than the project area around it: the money is the
 * administration's alone, and the project's own architect is one of the
 * parties paid there.
 */
export const Route = createFileRoute('/internal/projects/$id/finance')({
  validateSearch: listSearchValidator(financeListFilters),
  beforeLoad: async ({ context, location }) => {
    const { roles } = await requireAuth(context.queryClient, location.href)
    if (!holdsAny(roles, FINANCE_ROLES))
      throw new AccessDeniedError(location.pathname)
  },
  component: FinanceScreen,
})

function FinanceScreen() {
  const filters = useListFilters(financeListFilters, Route)
  return <FinanceView filters={filters} />
}
